/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProjectToLaborCost } from '../fn/labor-costs/add-project-to-labor-cost';
import { AddProjectToLaborCost$Params } from '../fn/labor-costs/add-project-to-labor-cost';
import { addUserToLaborCost } from '../fn/labor-costs/add-user-to-labor-cost';
import { AddUserToLaborCost$Params } from '../fn/labor-costs/add-user-to-labor-cost';
import { createLaborCost } from '../fn/labor-costs/create-labor-cost';
import { CreateLaborCost$Params } from '../fn/labor-costs/create-labor-cost';
import { deleteLaborCost } from '../fn/labor-costs/delete-labor-cost';
import { DeleteLaborCost$Params } from '../fn/labor-costs/delete-labor-cost';
import { getLaborCost } from '../fn/labor-costs/get-labor-cost';
import { GetLaborCost$Params } from '../fn/labor-costs/get-labor-cost';
import { LaborCostDto } from '../models/labor-cost-dto';
import { LaborCostDtoPage } from '../models/labor-cost-dto-page';
import { listLaborCosts } from '../fn/labor-costs/list-labor-costs';
import { ListLaborCosts$Params } from '../fn/labor-costs/list-labor-costs';
import { listUsableInProjectLaborCosts } from '../fn/labor-costs/list-usable-in-project-labor-costs';
import { ListUsableInProjectLaborCosts$Params } from '../fn/labor-costs/list-usable-in-project-labor-costs';
import { removeProjectFromLaborCost } from '../fn/labor-costs/remove-project-from-labor-cost';
import { RemoveProjectFromLaborCost$Params } from '../fn/labor-costs/remove-project-from-labor-cost';
import { removeUserFromLaborCost } from '../fn/labor-costs/remove-user-from-labor-cost';
import { RemoveUserFromLaborCost$Params } from '../fn/labor-costs/remove-user-from-labor-cost';
import { updateLaborCost } from '../fn/labor-costs/update-labor-cost';
import { UpdateLaborCost$Params } from '../fn/labor-costs/update-labor-cost';

@Injectable({ providedIn: 'root' })
export class LaborCostsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listLaborCosts()` */
  static readonly ListLaborCostsPath = '/v0/laborCosts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborCosts$Response(params?: ListLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDtoPage>> {
    return listLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborCosts(params?: ListLaborCosts$Params, context?: HttpContext): Observable<LaborCostDtoPage> {
    return this.listLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostDtoPage>): LaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `getLaborCost()` */
  static readonly GetLaborCostPath = '/v0/laborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborCost$Response(params: GetLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDto>> {
    return getLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborCost(params: GetLaborCost$Params, context?: HttpContext): Observable<LaborCostDto> {
    return this.getLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostDto>): LaborCostDto => r.body)
    );
  }

  /** Path part for operation `updateLaborCost()` */
  static readonly UpdateLaborCostPath = '/v0/laborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborCost$Response(params: UpdateLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborCost(params: UpdateLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.updateLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createLaborCost()` */
  static readonly CreateLaborCostPath = '/v0/laborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborCost$Response(params: CreateLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDto>> {
    return createLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborCost(params: CreateLaborCost$Params, context?: HttpContext): Observable<LaborCostDto> {
    return this.createLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostDto>): LaborCostDto => r.body)
    );
  }

  /** Path part for operation `deleteLaborCost()` */
  static readonly DeleteLaborCostPath = '/v0/laborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborCost$Response(params: DeleteLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborCost(params: DeleteLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listUsableInProjectLaborCosts()` */
  static readonly ListUsableInProjectLaborCostsPath = '/v0/laborCosts/usable-in-project';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUsableInProjectLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsableInProjectLaborCosts$Response(params: ListUsableInProjectLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostDtoPage>> {
    return listUsableInProjectLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUsableInProjectLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsableInProjectLaborCosts(params: ListUsableInProjectLaborCosts$Params, context?: HttpContext): Observable<LaborCostDtoPage> {
    return this.listUsableInProjectLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostDtoPage>): LaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `addProjectToLaborCost()` */
  static readonly AddProjectToLaborCostPath = '/v0/laborCosts/{id}/add-project';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProjectToLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProjectToLaborCost$Response(params: AddProjectToLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addProjectToLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProjectToLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProjectToLaborCost(params: AddProjectToLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.addProjectToLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeProjectFromLaborCost()` */
  static readonly RemoveProjectFromLaborCostPath = '/v0/laborCosts/{id}/remove-project';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProjectFromLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeProjectFromLaborCost$Response(params: RemoveProjectFromLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeProjectFromLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeProjectFromLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeProjectFromLaborCost(params: RemoveProjectFromLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.removeProjectFromLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addUserToLaborCost()` */
  static readonly AddUserToLaborCostPath = '/v0/laborCosts/{id}/add-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserToLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToLaborCost$Response(params: AddUserToLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addUserToLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addUserToLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToLaborCost(params: AddUserToLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.addUserToLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeUserFromLaborCost()` */
  static readonly RemoveUserFromLaborCostPath = '/v0/laborCosts/{id}/remove-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromLaborCost$Response(params: RemoveUserFromLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeUserFromLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromLaborCost(params: RemoveUserFromLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.removeUserFromLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
